export const environment = {
    production: true,
    API_URL: 'https://api.staff-staging.asport-bg.com',
    siteKey: '6LfkzLkqAAAAAMpbUn2Jq7rrL9um-pF41oc8d-xG',
    api: 'https://staff-staging-api.asport-bg.com',
    name: "STAGING"
};
